import { useTranslation } from "next-i18next";
import LokaliseMarkdownText from "@whoppah/components/text/LokaliseMarkdownText";
import SEO from "../common/seo";

export const Impressum = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO title={t("impressum:impressum-seo-title")} />
      <LokaliseMarkdownText
        lokaliseKey="impressum:impressum-content"
        className="flex flex-col items-center gap-4 p-2 text-center md:p-16"
      />
    </>
  );
};
